"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is the typical timeline for a sell-side M&A transaction?",
  answer: "Most mid-market transactions conclude within 6 to 9 months. This includes the initial valuation, preparation of marketing materials, buyer outreach, due diligence, and final closing. Our structured process ensures momentum is maintained while maximizing the value of your business legacy."
}, {
  question: "How does Blue Phoenix Ventures ensure confidentiality during the sale?",
  answer: "Confidentiality is our highest priority. We utilize blind teasers that omit identifying details and require strictly vetted Non-Disclosure Agreements (NDAs) before sharing any sensitive information. Our secure virtual data rooms ensure your proprietary data remains protected throughout the process."
}, {
  question: "What business sectors do you specialize in for investment?",
  answer: "We focus on high-growth and stable sectors including Food & Beverage, Agriculture, Manufacturing, Aerospace & Defense, and Energy. We specifically look for companies with $1M–$5M EBITDA where our operational expertise and capital can drive significant value creation."
}, {
  question: "How do you determine the valuation of my company?",
  answer: "We employ a multi-faceted approach combining Discounted Cash Flow (DCF) analysis, comparable company analysis, and recent transaction multiples. Beyond the numbers, we factor in your unique market position, intellectual property, and growth potential to ensure you receive maximum market value."
}, {
  question: "What is the difference between a financial and a strategic buyer?",
  answer: "Strategic buyers are often competitors or companies in related industries looking for synergies, while financial buyers (like Private Equity firms) focus on ROI and cash flow. BPV Consulting leverages our deep network to identify the right mix of both to create a competitive bidding environment."
}];
export default function IndustryKnowledgeFaq() {
  return <section data-section-id="223690" id="service-faq" className="bg-accent/30 text-foreground py-24 md:py-32 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-bold font-default tracking-tighter mb-4 text-primary">
            Strategic Advisory FAQ
          </h2>
          <p className="text-muted-foreground text-lg font-serif max-w-xl mx-auto">
            Expert insights on M&A processes, capital raises, and maximizing enterprise value.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`faq-${i}`} data-index={i} className="border-b border-border data-[state=open]:bg-card/50 backdrop-blur-sm px-4 md:px-6 transition-colors duration-300">
              <AccordionTrigger className="text-xl font-semibold font-default hover:no-underline py-6 text-left text-primary hover:text-ring transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base font-serif leading-relaxed pb-6 pr-8">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
        
        <div className="mt-12 text-center">
          <p className="text-sm font-mono uppercase tracking-widest text-ring">
            Still have questions? <Link to="/ContactPage" className="underline underline-offset-4 hover:text-primary transition-colors">Consult our partners</Link>
          </p>
        </div>
      </div>
    </section>;
}